import React from 'react';
import {PAGINATION} from "../../common/constant";

const initialState = {
    socketId: '',
    jobInformation: {limit: PAGINATION.LIMIT},
    agreement: {limit: PAGINATION.LIMIT},
    compensation: {limit: PAGINATION.LIMIT},
    myExit: {limit: PAGINATION.LIMIT},
    probation: {limit: PAGINATION.LIMIT},
    bankInformation: {limit: PAGINATION.LIMIT},

    employeeDirectory: {limit: PAGINATION.LIMIT},
    employeeList: {limit: PAGINATION.LIMIT},
    employeeProbation: {limit: PAGINATION.LIMIT},
    employeeResignation: {limit: PAGINATION.LIMIT},
    employeeAgreement: {limit: PAGINATION.LIMIT},
    employeeCompensation: {limit: PAGINATION.LIMIT},
    employeeCompensationGrid: {limit: PAGINATION.LIMIT},

    leaveAccrualDetail: {limit: PAGINATION.LIMIT},
    leaveHistory: {limit: PAGINATION.LIMIT},
    encashmentHistory: {limit: PAGINATION.LIMIT},
    leaveAdjustment: {limit: PAGINATION.LIMIT},
    leaveApplicationsFilter: {limit: PAGINATION.LIMIT},
    leaveEncashmentFilter: {limit: PAGINATION.LIMIT},
    leaveCalenderFilter: {limit: PAGINATION.LIMIT},
    leaveBalanceFilter: {limit: 20},

    myAttendance: {limit: PAGINATION.LIMIT},
    employeeAttendance: {limit: PAGINATION.LIMIT},
    attendanceUserVerification: {limit: PAGINATION.LIMIT},
    attendanceVerification: {limit: PAGINATION.LIMIT},
    attendanceRegularization: {limit: PAGINATION.LIMIT},
    inboxCommenAttendance: {limit: PAGINATION.LIMIT},
    workingDay: {limit: PAGINATION.LIMIT},
    nonWorkingDay: {limit: PAGINATION.LIMIT},
    shiftCalendar: {limit: PAGINATION.LIMIT},

    geoFencing: {limit: PAGINATION.LIMIT},
    biometrics: {limit: PAGINATION.LIMIT},
    biometricsUser: {limit: PAGINATION.LIMIT},
    shiftScheduler: {limit: PAGINATION.LIMIT},

    onBoardingFields: {limit: PAGINATION.LIMIT},
    onboardingUserList: {limit: PAGINATION.LIMIT},

};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'FILTER_JOB_INFORMATION': {
            const localState = {}
            if (action.payload.limit) localState.jobInformation = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_AGREEMENT': {
            const localState = {}
            if (action.payload.limit) localState.agreement = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_COMPENSATION': {
            const localState = {}
            if (action.payload.limit) localState.compensation = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_MY_EXIT': {
            const localState = {}
            if (action.payload.limit) localState.myExit = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_PROBATION': {
            const localState = {}
            if (action.payload.limit) localState.probation = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_BANK_INFORMATION': {
            const localState = {}
            if (action.payload.limit) localState.bankInformation = {limit: action.payload.limit};
            return {...state, ...localState}
        }

        case 'FILTER_EMPLOYEE_DIRECTORY': {
            const localState = {}
            if (action.payload.limit) localState.employeeDirectory = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_LIST': {
            const localState = {}
            if (action.payload.limit) localState.employeeList = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_PROBATION': {
            const localState = {}
            if (action.payload.limit) localState.employeeProbation = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_EXIT': {
            const localState = {}
            if (action.payload.limit) localState.employeeExit = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_AGREEMENT': {
            const localState = {}
            if (action.payload.limit) localState.employeeAgreement = {limit: action.payload.limit};
            if (action?.payload?.view) localState.employeeAgreement = {view: action?.payload?.view};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_COMPENSATION': {
            const localState = {}
            if (action.payload.limit) localState.employeeCompensation = {limit: action.payload.limit};
            if (action?.payload?.view) localState.employeeCompensation = {view: action?.payload?.view};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_COMPENSATION_GRID': {
            const localState = {}
            if (action.payload.limit) localState.employeeCompensationGrid = {limit: action.payload.limit};
            return {...state, ...localState}
        }

        case 'FILTER_LEAVE_ACCRUAL_DETAIL': {
            const localState = {}
            if (action.payload.limit) localState.leaveAccrualDetail = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_LEAVE_HISTORY': {
            const localState = {}
            if (action.payload.limit) localState.leaveHistory = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_ENCASHMENT_HISTORY': {
            const localState = {}
            if (action.payload.limit) localState.encashmentHistory = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_LEAVE_ADJUSTMENT': {
            const localState = {}
            if (action.payload.limit) localState.leaveAdjustment = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_LEAVE_APPLICATION': {
            const localState = {}
            if (action.payload.limit) localState.leaveApplicationsFilter = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_ENCASHMENT_APPLICATION': {
            const localState = {}
            if (action.payload.limit) localState.leaveEncashmentFilter = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_LEAVE_CALENDER': {
            const localState = {}
            if (action.payload.limit) localState.leaveCalenderFilter = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_LEAVE_BALANCE': {
            const localState = {}
            if (action.payload.limit) localState.leaveBalanceFilter = {limit: action.payload.limit};
            return {...state, ...localState}
        }

        case 'FILTER_MY_ATTENDANCE': {
            const localState = {}
            if (action.payload.limit) localState.myAttendance = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_EMPLOYEE_ATTENDANCE': {
            const localState = {}
            if (action.payload.limit) localState.employeeAttendance = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_ATTENDANCE_USER_VERIFICATION': {
            const localState = {}
            if (action.payload.limit) localState.attendanceUserVerification = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_ATTENDANCE_VERIFICATION': {
            const localState = {}
            if (action.payload.limit) localState.attendanceVerification = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_ATTENDANCE_REGULARIZATION': {
            const localState = {}
            if (action.payload.limit) localState.attendanceRegularization = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_WORKING_DAY': {
            const localState = {}
            if (action.payload.limit) localState.workingDay = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_NON_WORKING_DAY': {
            const localState = {}
            if (action.payload.limit) localState.nonWorkingDay = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_GEO_FENCING': {
            const localState = {}
            if (action.payload.limit) localState.geoFencing = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_BIOMETRICS': {
            const localState = {}
            if (action.payload.limit) localState.biometrics = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_BIOMETRICS_USER': {
            const localState = {}
            if (action.payload.limit) localState.biometricsUser = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_SHIFT_SCHEDULER': {
            const localState = {}
            if (action.payload.limit) localState.shiftScheduler = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'FILTER_SHIFT_CALENDAR': {
            const localState = {}
            if (action.payload.limit) localState.shiftCalendar = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'SET_INBOX_ATTENDANCE_MULTI_SELECTED': {
            const localState = {}
            if (action.payload.limit) localState.attendanceMulti = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'INBOX_COMMEN_FILTER' : {
            const localState = {}
            if (action.payload.limit) localState.inboxCommenAttendance = {limit: action.payload.limit};
            return {...state, ...localState}
        }
        case 'SET_ONBOARDING_USER_LIST': {
            return {...state, onboardingUserList: {...state.onboardingUserList, ...action.payload}};
        }
        default: {
            return state;
        }
    }
}
